import {
  MEDIA_ENTRY_APPLICATION,
  MEDIA_ENTRY_CONTENT_GROUP,
  MEDIA_ENTRY_FOLDER,
  MEDIA_ENTRY_USER_CONTENT,
  MEDIA_ENTRY_WEBPAGE,
  MEDIA_TABLE_FILTER_TYPE,
  MEDIA_TABLE_FILTER_TAG,
  MEDIA_TABLE_FILTER_FOLDER,
} from "fleet/constant/media-library";
import PropTypes from "prop-types";

const PropTypeMediaFilterFields = PropTypes.oneOf([
  MEDIA_TABLE_FILTER_TYPE,
  MEDIA_TABLE_FILTER_TAG,
  MEDIA_TABLE_FILTER_FOLDER,
]);

const PropTypeMediaEntryTypes = PropTypes.oneOf([
  MEDIA_ENTRY_APPLICATION,
  MEDIA_ENTRY_CONTENT_GROUP,
  MEDIA_ENTRY_FOLDER,
  MEDIA_ENTRY_USER_CONTENT,
  MEDIA_ENTRY_WEBPAGE,
]);

const PropTypeMediaEntry = PropTypes.shape({
  _rowNum: PropTypes.number,
  accountId: PropTypes.number,
  archived: PropTypes.bool,
  conflictsWith: PropTypes.arrayOf(PropTypes.string),
  content: PropTypes.array,
  duration: PropTypes.number,
  folderId: PropTypes.number,
  folderName: PropTypes.string,
  friendlyType: PropTypes.oneOf([
    "Application",
    "Folder",
    "Image",
    "Media Group",
    "Video",
    "Web Page",
  ]),
  id: PropTypes.number,
  mimeType: PropTypes.string,
  name: PropTypes.string,
  displayName: PropTypes.string,
  numberOfSpots: PropTypes.number,
  tag: PropTypes.string,
  type: PropTypeMediaEntryTypes,
  uploadDate: PropTypes.string,
  url: PropTypes.string,
  userId: PropTypes.number,
});

const PropTypeMediaTableColumns = PropTypes.oneOf([
  "friendlyType",
  "name",
  "tag",
  "uploadDate",
  "url",
]);

export {
  PropTypeMediaEntry,
  PropTypeMediaEntryTypes,
  PropTypeMediaFilterFields,
  PropTypeMediaTableColumns,
};
